import React, { useState, useEffect } from 'react';
import { graphql } from 'react-relay';
import qs from 'qs';

import CheckoutPage from './CheckoutPage';
import QueryHandler from '../components/misc/QueryHandler';
import { UserConsumer } from '../components/context/UserContext';

const CheckoutPageQueryRenderer = (props) => {
  const [adyenRedirectResult, setAdyenRedirectResult] = useState(undefined);

  useEffect(() => {
    setAdyenRedirectResult(
      qs.parse(
        props.location.search,
        { ignoreQueryPrefix: true }
      ).redirectResult
    );
  }, []);

  return (
    <UserConsumer>
      {({ isLoggedIn }) => (
        <QueryHandler
          query={graphql`
            query CheckoutPageQueryRendererQuery($isLoggedIn: Boolean, $noAdyenRedirectResult: Boolean, $adyenRedirectResult: String) {
              viewer {
                ...CheckoutPage_viewer
              }
            }
          `}
          variables={{
            isLoggedIn: isLoggedIn,
            noAdyenRedirectResult: adyenRedirectResult === undefined,
            adyenRedirectResult: adyenRedirectResult,
          }}
          render={props => {
            return <CheckoutPage isLoggedIn={isLoggedIn} viewer={props.viewer} />;
          }}
        />
      )}
    </UserConsumer>
  );
}

export default CheckoutPageQueryRenderer;
